import { render, staticRenderFns } from "./ManageFileInfo.vue?vue&type=template&id=6d2dc05b"
import script from "./ManageFileInfo.vue?vue&type=script&lang=js"
export * from "./ManageFileInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports